import { render } from "./UserQuestionModal.vue?vue&type=template&id=b7f7b5d4"
import script from "./UserQuestionModal.vue?vue&type=script&lang=js"
export * from "./UserQuestionModal.vue?vue&type=script&lang=js"

import "./UserQuestionModal.vue?vue&type=style&index=0&id=b7f7b5d4&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__